"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PORTAL_SEARCH_HIGHLIGHT_SELECTED_COLOR = exports.PORTAL_SEARCH_HIGHLIGHT_COLOR = exports.PORTAL_RE_ARCHITECTURE_ENABLED = void 0;
var PORTAL_RE_ARCHITECTURE_ENABLED = exports.PORTAL_RE_ARCHITECTURE_ENABLED = 'portal-re-architecture-enabled';
var PORTAL_SEARCH_HIGHLIGHT_COLOR = exports.PORTAL_SEARCH_HIGHLIGHT_COLOR = '#fbdf5166';
var PORTAL_SEARCH_HIGHLIGHT_SELECTED_COLOR = exports.PORTAL_SEARCH_HIGHLIGHT_SELECTED_COLOR = '#ffa50099';
//# sourceMappingURL=constants.js.map